(() => {
  const headingText = (el) => {
    if (!el || el.nodeType !== 1) return null;
    let link = null;
    if (el.matches('a[href="#"]')) link = el;
    else if (el.children.length === 1 && el.firstElementChild.matches('a[href="#"]')
      && el.textContent.trim() === el.firstElementChild.textContent.trim()) link = el.firstElementChild;
    if (!link) {
      if (el.matches('p, h2, h3, h4, h5, h6, strong, b') && !el.querySelector('img, iframe')) {
        const t = el.textContent.replace(/\s+/g, ' ').trim();
        return t && /[A-Z]/.test(t) && t === t.toUpperCase() && t.length < 40 && !/[.:]$/.test(t) ? t : null;
      }
      return null;
    }
    const t = link.textContent.replace(/\s+/g, ' ').trim();
    return t && t === t.toUpperCase() && t.length < 40 ? t : null;
  };

  const isCapsLink = (a) => {
    const t = a.textContent.replace(/\s+/g, ' ').trim();
    return t && t === t.toUpperCase() && t.length < 40;
  };

  // A heading link stuck inside a paragraph (editor merges lines): split the paragraph around it
  const splitStuckHeadings = (box) => {
    for (const p of [...box.querySelectorAll(':scope > p')]) {
      const links = [...p.querySelectorAll('a[href="#"]')].filter(isCapsLink);
      if (!links.length || headingText(p)) continue;
      const parts = [];
      let cur = document.createElement('p');
      const flush = () => { if (cur.textContent.trim() || cur.querySelector('img, iframe')) parts.push(cur); cur = document.createElement('p'); };
      for (const n of [...p.childNodes]) {
        const top = links.find((a) => a === n || (n.nodeType === 1 && n.contains(a)));
        if (top && (top === n || n.textContent.trim() === top.textContent.trim())) {
          flush();
          const h = document.createElement('p'); h.append(top); parts.push(h);
        } else if (!(n.nodeType === 1 && n.tagName === 'BR' && !cur.childNodes.length)) {
          cur.append(n);
        }
      }
      flush();
      p.replaceWith(...parts);
    }
  };

  // Headings nested inside lists/spans/paragraphs (editor or old-site markup): lift every heading to the top level
  const INLINE = new Set(['A', 'SPAN', 'STRONG', 'B', 'EM', 'I', 'U', 'SMALL', 'SUP', 'SUB', 'MARK', 'CODE', 'FONT']);
  const isHeadLink = (n) => n.nodeType === 1 && n.matches('a[href="#"]') && isCapsLink(n);
  const holdsHead = (n) => n.nodeType === 1 && [...n.querySelectorAll('a[href="#"]')].some(isCapsLink);
  const lift = (node, out) => {
    let run = null;
    const flush = () => { if (run && (run.textContent.trim() || run.querySelector('img, iframe, a'))) out.push(run); run = null; };
    for (const c of [...node.childNodes]) {
      if (isHeadLink(c)) { flush(); const p = document.createElement('p'); p.append(c); out.push(p); continue; }
      if (holdsHead(c)) { flush(); lift(c, out); continue; }
      if (c.nodeType === 1 && c.tagName === 'BR') { flush(); continue; }
      if (c.nodeType === 3 || (c.nodeType === 1 && INLINE.has(c.tagName))) { (run ||= document.createElement('p')).append(c); continue; }
      if (c.nodeType === 1) { flush(); out.push(c); }
    }
    flush();
  };
  const liftHeadings = (box) => {
    const nested = [...box.querySelectorAll('a[href="#"]')].filter(isCapsLink).some((a) => {
      const top = [...box.children].find((k) => k === a || k.contains(a));
      return top !== a && !(top && top.tagName === 'P' && top.children.length === 1 && top.textContent.trim() === a.textContent.trim());
    });
    if (!nested) return;
    const out = [];
    lift(box, out);
    box.replaceChildren(...out);
  };

  // Editor bullets: drop empty bullets; a list with a single bullet becomes a plain paragraph
  const cleanLists = (box) => {
    box.querySelectorAll('li').forEach((li) => { if (!li.textContent.trim() && !li.querySelector('img, iframe')) li.remove(); });
    box.querySelectorAll('ul, ol').forEach((ul) => {
      const items = ul.querySelectorAll(':scope > li');
      if (!ul.textContent.trim() && !ul.querySelector('img, iframe')) { ul.remove(); return; }
      if (items.length === 1) { const li = items[0]; const p = document.createElement(li.querySelector('p, ul, ol, div') ? 'div' : 'p'); p.append(...li.childNodes); ul.replaceWith(p); }
    });
    box.querySelectorAll(':scope > p').forEach((p) => {
      if (!p.textContent.replace(/[\s.]/g, '') && !p.querySelector('img, iframe, a')) p.remove();
    });
  };

  const titleCase = (t) => t.toLowerCase()
    .replace(/(^|[\s&/(-])([a-z])/g, (m, a, b) => a + b.toUpperCase());

  const unwrapList = (n) => {
    if (n.nodeType === 1 && n.tagName === 'UL' && !n.querySelector(':scope > li')) {
      const div = document.createElement('div');
      div.append(...n.childNodes);
      return div;
    }
    if (n.nodeType === 3) {
      const p = document.createElement('p');
      p.append(n);
      return p;
    }
    return n;
  };

  function enhance(box) {
    if (box.dataset.done) return;
    box.dataset.done = '1';

    for (const f of box.querySelectorAll('iframe')) {
      const w = +f.getAttribute('width') || 16;
      const h = +f.getAttribute('height') || 9;
      const v = document.createElement('div');
      v.className = `dj-video${h > w ? ' dj-video--tall' : ''}`;
      v.style.setProperty('--dj-ratio', `${w} / ${h}`);
      const wrap = f.parentElement !== box && f.parentElement.children.length === 1 ? f.parentElement : f;
      wrap.replaceWith(v);
      v.append(f);
    }

    let flattened = true;
    while (flattened) {
      flattened = false;
      for (const el of [...box.children]) {
        if ((el.tagName === 'SPAN' || el.tagName === 'DIV') && !el.classList.contains('dj-video')
          && el.querySelector('a[href="#"]')) {
          el.replaceWith(...el.childNodes);
          flattened = true;
        }
      }
    }

    box.querySelectorAll('.dj-video').forEach((v, i) => { if (i > 0) v.remove(); });

    liftHeadings(box);
    splitStuckHeadings(box);
    cleanLists(box);
    const nodes = [...box.childNodes];
    if (!nodes.some((n) => headingText(n))) return;

    const sections = [];
    let current = { title: null, nodes: [] };
    for (const n of nodes) {
      const t = headingText(n);
      if (t) {
        sections.push(current);
        current = { title: t, nodes: [] };
      } else if (!(n.nodeType === 3 && !n.textContent.trim())) {
        current.nodes.push(n);
      }
    }
    sections.push(current);

    const out = document.createDocumentFragment();
    const videos = [];
    for (const s of sections) {
      s.nodes = s.nodes.filter((n) => {
        if (n.nodeType === 1 && n.classList.contains('dj-video')) { videos.push(n); return false; }
        return true;
      });
      if (!s.nodes.length) continue;
      if (!s.title) {
        s.nodes.forEach((n) => out.append(unwrapList(n)));
        continue;
      }
      const d = document.createElement('details');
      d.className = 'dj-acc';
      d.innerHTML = '<summary></summary><div class="dj-acc__body"></div>';
      d.querySelector('summary').textContent = titleCase(s.title);
      const body = d.querySelector('.dj-acc__body');
      s.nodes.forEach((n) => body.append(unwrapList(n)));
      out.append(d);
    }
    out.querySelectorAll('.dj-acc .dj-video').forEach((v) => videos.push(v));
    if (videos.length) out.append(videos[0]);
    videos.slice(1).forEach((v) => v.remove());
    out.querySelectorAll('.dj-acc__body div:empty').forEach((e) => e.remove());
    box.replaceChildren(out);
  }

  const run = () => document.querySelectorAll('[data-dj-pattern-details]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);

  const placePins = () => document.querySelectorAll('.dj-pin').forEach((pin) => {
    const m = pin.closest('.product-media'); const img = m && m.querySelector('img');
    if (!img || !img.naturalWidth) return;
    const mr = m.getBoundingClientRect(), ir = img.getBoundingClientRect();
    const scale = Math.min(ir.width / img.naturalWidth, ir.height / img.naturalHeight);
    const w = img.naturalWidth * scale, h = img.naturalHeight * scale;
    const left = ir.left - mr.left + (ir.width - w) / 2, top = ir.top - mr.top + (ir.height - h) / 2;
    pin.style.left = `${Math.max(0, left) + 10}px`; pin.style.top = `${Math.max(0, top) + 10}px`;
  });
  const pinsLater = () => { placePins(); document.querySelectorAll('.product-media img').forEach((i) => { if (!i.complete) i.addEventListener('load', placePins, { once: true }); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pinsLater); else pinsLater();
  window.addEventListener('load', placePins);
  window.addEventListener('resize', placePins);
})();
